import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class Blog {
  constructor(el) {
    this.el = el
    this.grid = this.el.querySelector('.blog--grid')
    this.filtersEl = this.el.querySelector('.blog--filter')
    this.init()
  }

  init() {
    if (!this.grid) return

    this.initFilter()
    this.reveal()
  }

  initFilter() {
    if (!this.filtersEl) return

    const items = [...this.grid.querySelectorAll('.blog--item')]

    this.filtersEl.addEventListener('click', (e) => {
      const li = e.target.closest('li[data-filter]')
      if (!li) return

      const filterValue = li.getAttribute('data-filter') || '*'

      items.forEach((item) => {
        const inner = item.querySelector('.blog--card-inner')
        const match = filterValue === '*' || item.matches(filterValue)
        const wasHidden = item.classList.contains('is-hidden')

        // display:none ne se transitionne pas : on anime d'abord opacity/transform,
        // puis on ne sort l'item du flow (ou on l'y remet) qu'une fois l'animation jouée.
        if (match && wasHidden) {
          item.classList.remove('is-hidden')
          gsap.fromTo(inner, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.4, ease: 'power2.out' })
        } else if (!match && !wasHidden) {
          gsap.to(inner, {
            opacity: 0,
            y: -20,
            duration: 0.3,
            ease: 'power2.in',
            onComplete: () => item.classList.add('is-hidden'),
          })
        }
      })

      this.filtersEl.querySelectorAll('li').forEach(n => n.classList.remove('is-active'))
      li.classList.add('is-active')
    })
  }

  reveal() {
    this.grid.querySelectorAll('.blog--card-inner').forEach((inner) => {
      gsap.set(inner, { y: 40, opacity: 0 })

      gsap.to(inner, {
        y: 0,
        opacity: 1,
        duration: 0.9,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: inner,
          start: 'top 88%',
          toggleActions: 'play none none none',
        },
      })
    })
  }
}
